module.exports = __webpack_public_path__ + "static/media/GEL.7a8d521e.png";